import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'urlsafe', standalone: true })
export class UrlSafePipe implements PipeTransform {
  transform(value?: string): string | undefined {
    if (!value) {
      return value;
    }

    value = value
      .replace(/ß/gi, 'ss')
      .replace(/ü/gi, 'ue')
      .replace(/ö/gi, 'oe')
      .replace(/ä/gi, 'ae')
      .replace(/[âàáą]/gi, 'a')
      .replace(/[çčć]/gi, 'c')
      .replace(/[èéěêę]/gi, 'e')
      .replace(/ď/gi, 'd')
      .replace(/[îí]/gi, 'i')
      .replace(/[łľĺ]/gi, 'l')
      .replace(/[ôóő]/gi, 'o')
      .replace(/[ňń]/gi, 'n')
      .replace(/ř/gi, 'r')
      .replace(/[śš]/gi, 's')
      .replace(/ť/gi, 't')
      .replace(/[ûùúůű]/gi, 'u')
      .replace(/ý/gi, 'y')
      .replace(/[žżź]/gi, 'z')
      .replace(/[/+ ]/gi, '-')
      .replace(/%26/g, '') // needed to remove & (%26) from canonical
      .replace(/[^a-z0-9-]+/gi, '')
      .toLowerCase();

    while (value.includes('--')) {
      // as loop in case of '----' -> '--' -> '-'
      value = value.replace('--', '-');
    }
    if (value.startsWith('-')) {
      value = value.slice(1);
    }
    if (value.endsWith('-')) {
      value = value.slice(0, -1);
    }
    return value;
  }
}
